import React from "react";
import styles from "./SterilizersDetail.module.css";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";

const SterilizersDetail = ({
  sterilizerData,
  t,
  locale,
  handleClose,
  open,
}) => {
  return (
    <ModalQ handleClose={handleClose} open={open} title={"Sterilizer Detail"}>
      <div className={styles.detailContainer}>
        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Name", locale) || "Name"}:
            </label>
            <div className={styles.detailValue}>
              {sterilizerData.name || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Brand", locale) || "Brand"}:
            </label>
            <div className={styles.detailValue}>
              {sterilizerData.brand || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Model", locale) || "Model"}:
            </label>
            <div className={styles.detailValue}>
              {sterilizerData.modelName || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Method", locale) || "Method"}:
            </label>
            <div className={styles.detailValue}>
              {sterilizerData.methodName || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Observations", locale) || "Observations"}:
            </label>
            <div className={styles.detailValue}>
              {sterilizerData.observations || "-"}
            </div>
          </div>
          <div style={{marginTop: "28px"}}> 
          <CheckBoxQ
            checked={sterilizerData.active}
            disabled={true}
            label={t("activeSpan") || "Active"}
          />
          </div>
        </div>
      </div>
    </ModalQ>
  );
};

export default SterilizersDetail;
